'use client';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '@ifixit/ui/lib/utils';
import { type ComponentProps } from 'react';

function Popover({ ...props }: ComponentProps<typeof PopoverPrimitive.Root>) {
   return <PopoverPrimitive.Root {...props} />;
}

function PopoverTrigger({ ...props }: ComponentProps<typeof PopoverPrimitive.Trigger>) {
   return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />;
}

function PopoverAnchor({ ...props }: ComponentProps<typeof PopoverPrimitive.Anchor>) {
   return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />;
}

function PopoverContent({
   className,
   sideOffset = 4,
   align = 'center',
   children,
   ...props
}: ComponentProps<typeof PopoverPrimitive.Content>) {
   return (
      <PopoverPrimitive.Portal>
         <PopoverPrimitive.Content
            data-slot="popover-content"
            align={align}
            sideOffset={sideOffset}
            className={cn(
               'bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-popover-content-available-height) min-w-[8rem] origin-(--radix-popover-content-transform-origin) overflow-x-hidden overflow-y-auto border rounded-xl p-4 shadow-md relative w-80',
               className
            )}
            {...props}
         >
            {children}
         </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
   );
}

export { Popover, PopoverAnchor, PopoverTrigger, PopoverContent };

// Re-export primitives for advanced usage
export {
   Root as PopoverRoot,
   Trigger as PopoverPrimitiveTrigger,
   Portal as PopoverPortal,
   Content as PopoverPrimitiveContent,
   Arrow as PopoverArrow,
} from '@radix-ui/react-popover';
